// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    suggestionMobileStyle: 'style2',
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  },
};

(function () {
  BoostPFS.inject(this);

  InstantSearchMobile.prototype.afterShowSearchBoxMobile = function (searchBoxId) {
    if (!searchBoxId) searchBoxId = this.searchBoxId;
  };

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };
})();
